import { SyntheticEvent, ReactNode, FC } from 'react';
import { Tabs as MuiTabs, Box } from '@mui/material';
import { tabsStyles } from './tabs.styles';
import { clsx } from '../../../utils';

interface TabsProps {
  selectedTabIndex: number;
  handleTabChange: (event: SyntheticEvent, newValue: number) => void;
  children: ReactNode[];
}

export const Tabs: FC<TabsProps> = ({ selectedTabIndex, handleTabChange, children }) => (
  <Box sx={clsx(tabsStyles['wrapper'])}>
    <MuiTabs
      value={selectedTabIndex}
      onChange={handleTabChange}
      sx={clsx(tabsStyles['innerWrapper'])}
    >
      {children}
    </MuiTabs>
  </Box>
)
